import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { WHATSAPP_LINK } from "@/lib/constants";

const NAV_LINKS = [
  { label: "Products", to: "/#products" },
  { label: "About", to: "/#why" },
  { label: "Contact", to: "/#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const onHome = pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Resolve href: on home use pure anchor for smooth scroll; elsewhere use root path + hash
  const hrefFor = (to) => (onHome ? to.replace(/^\//, "") : to);

   const location = useLocation();
    let logo = "/logo.png";

  if (location.pathname.includes("radagent")) {
    logo = "/RadAgentLogo.png";
  } else if (location.pathname.includes("radscribe")) {
    logo = "/RadScribeLogo.png";
  }
  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-[#071B34]/85 border-b border-white/5"
          : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <a
          href="/"
          data-testid="nav-logo"
          className="flex items-center gap-2 group w-40"
        >
          <img src={logo} height={200} width={500}  />
          {/* <span className="relative inline-flex items-center justify-center w-9 h-9 rounded-lg bg-gradient-to-br from-[#14D6C7] to-[#2EE8FF]">
            <span className="absolute inset-[3px] rounded-md bg-[#071B34]" />
            <span className="relative w-1.5 h-1.5 rounded-full bg-[#2EE8FF] shadow-[0_0_10px_#2EE8FF]" />
          </span>
          <span className="wordmark text-white text-lg font-manrope">ZELTAA</span> */}
        </a>

        <ul className="hidden md:flex items-center gap-10">
          {NAV_LINKS.map((link) => (
            <li key={link.to}>
              <a
                data-testid={`nav-link-${link.label.toLowerCase()}`}
                href={hrefFor(link.to)}
                className="link-underline text-sm font-medium text-white/80 hover:text-white transition-colors font-manrope"
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-3">
          <a
            data-testid="nav-book-demo-btn"
            href={WHATSAPP_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="hidden sm:inline-flex btn-shine items-center gap-2 px-5 py-2.5 rounded-full bg-[#14D6C7] text-[#071B34] text-sm font-semibold hover:bg-[#2EE8FF] transition-colors shadow-[0_0_0_1px_rgba(46,232,255,0.2),0_8px_24px_-8px_rgba(20,214,199,0.6)]"
          >
            Book a Demo
            <ArrowUpRight className="w-4 h-4" strokeWidth={2.2} />
          </a>
          <button
            data-testid="nav-mobile-toggle"
            aria-label="Toggle menu"
            onClick={() => setOpen((v) => !v)}
            className="md:hidden inline-flex items-center justify-center w-10 h-10 rounded-lg text-white/90 border border-white/10"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </nav>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden absolute top-20 left-0 right-0 bg-[#071B34]/95 backdrop-blur-xl border-b border-white/5"
        >
          <ul className="flex flex-col p-6 gap-5">
            {NAV_LINKS.map((link) => (
              <li key={link.to}>
                <a
                  href={hrefFor(link.to)}
                  onClick={() => setOpen(false)}
                  className="text-white/90 text-base font-medium"
                >
                  {link.label}
                </a>
              </li>
            ))}
            <li>
              <a
                href={WHATSAPP_LINK}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => setOpen(false)}
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-[#14D6C7] text-[#071B34] font-semibold"
              >
                Book a Demo
                <ArrowUpRight className="w-4 h-4" />
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}
